<template>
  <div>
    <div v-if="!dataloaded || !userDataLoaded" class="blackbox-loader"></div>

    <v-container v-if="dataloaded && userDataLoaded"  grid-list-md class="ma-0 pa-2" fluid>
      <v-layout row wrap>
        <v-flex md3 xs12 v-if="companies.length > 1 && !this.demoMode">
          <v-select
            class="ma-1"
            :items="filteredCompanies"
            :color="companyPrimaryColor"
            :item-color="companyPrimaryColor"
            :background-color="$vuetify.theme.themes[theme].menu"    
            item-text="name"
            item-value="id"
            v-on:input="loadMembershipData()"
            v-model="activeComp"
            no-data-text="Geen bedrijven gevonden."
            label="Selecteer bedrijf"
            outlined
            hide-details
            dense>
            <template v-slot:prepend-item>
              <v-list-item>
                <v-list-item-content  class="pt-0" >
                  <v-text-field
                    :color="companyPrimaryColor"
                    placeholder="Zoeken"
                    prepend-inner-icon="search"
                    clearable
                    v-model="searchCompanies"
                    hide-details
                    dense
                  ></v-text-field>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <div v-if="searchCompanies.length > 0" style="padding: 4px 17px 3px 17px; background-color:rgba(0,0,0, 0.02); color: rgba(0, 0, 0, 0.6); text-align: center; font-size: 12px">{{ filteredCompanies.length }} van {{ companies.length }} bedrijven</div>
              <v-divider v-if="searchCompanies.length > 0"></v-divider>
            </template>
          </v-select>
        </v-flex>
        <v-flex  md9 xs12>

        </v-flex>
      </v-layout>
    </v-container>

    <div v-if="dataloaded && userDataLoaded && !deleting && memberships.length > 0" class="mt-5">
      <div class="content-box">

        <div>
          <v-btn v-for="year in yearsToSelect" class="ma-2" :key="year" color="primary" :outlined="year != selectedYear" @click="loadMembershipData(year)">{{ year }}</v-btn>
        </div>
        <v-card>
          <v-card-title>
            <v-text-field
              style="max-width: 300px;"
              v-model="search"
              :color="companyPrimaryColor"
              placeholder="Zoeken"
              outlined
              hide-details     
              background-color="#fff"                                                
              prepend-inner-icon="search"
              autocomplete="disabled"
              clearable>
            </v-text-field>
            <v-spacer></v-spacer>
            <div class="header-edit-button">
              <v-tooltip bottom>
                <template v-slot:activator="{on}">
                  <v-btn v-on="on" fab darken color="primary" @click="addNewMembership()">
                    <v-icon darken>add</v-icon>
                  </v-btn>
                </template>
                <span style="color: #fff;">Abonnement afsluiten</span>
              </v-tooltip>
            </div>
          </v-card-title>

          <v-data-table
            :headers="headers"
            :items="memberships"
            :search="search"
            :itemsPerPage.sync="queuePages"
            :page.sync="membershipSelectedPage"
            @page-count="membershipSelectorPages"
            v-model="selected"
            show-expand
            single-expand
            hide-default-footer

            :no-results-text="`Geen resultaten gevonden voor: ${search}`"
            >
            <template v-slot:item="{item, isExpanded, expand}">
              <tr>
                <td>{{ item.dateAddedFormatted }}u</td>
                <td>{{ getMembershipType(item.type) }}</td>
                <td>{{ item.firstName }} {{ item.lastName }}</td>     
                <td>{{ getBranchName(item.branch) }}</td>
                <td>&euro; {{ item.amount }}</td>
                <td><v-btn icon @click="showPreviewMembership(item)" ><v-icon :color="$vuetify.theme.themes[theme].text" dark>mdi-download</v-icon></v-btn></td>
                
                <td class="text-right">
                  <v-btn v-if="userRole == 'superadmin' || userRole == 'admin' || userRole == 'manager'"  icon @click="deleteMembershipDialog(item)"><v-icon :color="$vuetify.theme.themes[theme].text" dark>mdi-delete</v-icon></v-btn>
                  <v-tooltip v-if="!isExpanded" bottom>
                    <template v-slot:activator="{on}">
                      <v-btn  v-on="on" icon @click="expand(true)" ><v-icon :color="$vuetify.theme.themes[theme].text" dark>expand_more</v-icon></v-btn>
                    </template>
                    <span style="color: #fff;">Meer informatie tonen</span>
                  </v-tooltip>

                  <v-tooltip v-if="isExpanded" bottom>
                    <template v-slot:activator="{on}">
                      <v-btn  v-on="on" icon @click="expand(false)" v-if="isExpanded"><v-icon :color="$vuetify.theme.themes[theme].text" dark>expand_less</v-icon></v-btn>
                    </template>
                    <span style="color: #fff;">Meer informatie verbergen</span>
                  </v-tooltip>
                </td>
              </tr>
            </template>
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length" style="padding: 0;">
                <v-card flat>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <b>Extra informatie:</b><br>
                        {{ item.street }} {{ item.number }}<br>
                        {{ item.zipcode }} {{ item.city }}<br>
                        {{ item.birthday }} <br><br>
                        <div v-if="item.iban">
                          <b>IBAN:</b><br>
                          {{ item.iban }} <br><br>
                        </div>
                        
                      </v-flex>
                      <v-flex xs4 v-if="item.clientIdUrl">
                        <b>Paspoort/ID:</b><br>
                        <v-img width="250px" :src="item.clientIdUrl"></v-img>
                      </v-flex>
                      <v-flex xs4 v-if="item.clientCardUrl">
                        <b>Bankpas:</b><br>
                        <v-img width="250px" :src="item.clientCardUrl"></v-img>
                      </v-flex>

                      <v-flex xs4>
                        <b>Handtekening:</b><br>
                        <v-img width="250px" :src="item.clientSignature"></v-img>
                      </v-flex>
                    </v-layout>
      
                  </v-card-text>
                </v-card>
              </td>
            </template>
          </v-data-table>
          <div class="text-center pa-4" v-if="memberships.length > 20">
            <v-pagination
              circle
              v-model="membershipSelectedPage"
              :length="membershipSelectorPages"
              :total-visible="9"
            ></v-pagination>
          </div>
        </v-card>

        



      </div>
    </div>

    <div style="width: 350px; margin: 50px auto;" class="text-center" v-if="dataloaded && userDataLoaded && !deleting && memberships.length == 0">
      <p>Er zijn geen formulieren ingevuld</p>
      <div class="text-center">
        <v-tooltip bottom>
          <template v-slot:activator="{on}">
            <v-btn v-on="on" fab darken color="primary" style="display: block; margin: 15px auto;" @click="addNewMembership()">
              <v-icon darken>add</v-icon>
            </v-btn>
          </template>
          <span style="color: #fff;">Voeg een nieuwe abonnement toe. </span>
        </v-tooltip>
      </div>
    </div>

    <!-- / New Membership Dialog \ -->
      <add-membership-form :activeCompData="activeCompData" @updateData="updateData()"></add-membership-form>
    <!-- \ New Membership Dialog / -->

    <v-dialog v-model="previewMembershipDialog" scrollable max-width="600px" persistent>
    <v-card>
      <v-card-title class="pr-2" :style=" { backgroundColor: companyPrimaryColor }">
        <h2 style="color:white">Downloaden</h2>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="previewMembershipDialog = false">
          <v-icon dark color="white">close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text class="py-2" id="membership-wrapper">
        <v-container grid-list-md fluid class="ma-0 pa-0">
          <v-layout row wrap class="ma-0 pa-0 pb-4 text-center" v-if="activeCompData && activeCompData.logoUrl">
            <v-flex xs12>
              <v-img style="margin: 20px auto" width="100px" :src="activeCompData.logoUrl"></v-img>
            </v-flex>
            <v-flex xs12>
              <h2>Beauty by Roos Abonnement</h2>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="ma-0 pa-0 pt-4">
            <v-flex xs6><strong>Naam: </strong></v-flex>
            <v-flex xs6> {{ previewMembership.firstName }} {{ previewMembership.lastName }}</v-flex>
          </v-layout>
          <v-layout row wrap class="ma-0 pa-0 ">
            <v-flex xs6><strong>Adres: </strong></v-flex>
            <v-flex xs6> {{ previewMembership.street }} {{ previewMembership.lastName }}</v-flex>
            <v-flex xs6></v-flex>
            <v-flex xs6> {{ previewMembership.zipcode }} {{ previewMembership.city }}</v-flex>
          </v-layout>
           
          <v-layout row wrap class="ma-0 pa-0 pt-4 ">
            <v-flex xs6><strong>Type: </strong></v-flex>
            <v-flex xs6> {{ getMembershipType(previewMembership.type) }} </v-flex>
          </v-layout>
           <v-layout row wrap class="ma-0 pa-0 ">
            <v-flex xs6><strong>Bedrag: </strong></v-flex>
            <v-flex xs6> &euro; {{ previewMembership.amount }} </v-flex>
          </v-layout>
          <v-layout row wrap class="ma-0 pa-0 pt-4 ">
            <v-flex xs6><strong>Vestiging: </strong></v-flex>
            <v-flex xs6> {{ getBranchName(previewMembership.branch) }} </v-flex>
          </v-layout>
          <v-layout row wrap class="ma-0 pa-0">
            <v-flex xs6><strong>Datum en tijd : </strong></v-flex>
            <v-flex xs6> {{ previewMembership.dateAddedFormatted }} </v-flex>
          </v-layout>
          <v-layout row wrap class="ma-0 pa-0">
            <v-flex xs6><strong>Akkoord met Algemene Voorwaarden: </strong></v-flex>
            <v-flex xs6>https://beautybyroos.nl/algemene-voorwaarden/</v-flex>
          </v-layout>
          <v-layout row wrap class="ma-0 pa-0 pt-4 ">
            <v-flex xs6 v-if="previewMembership.clientIdUrl">
              <b>Paspoort/ID:</b><br>
              <v-img width="250px" :src="previewMembership.clientIdUrl"></v-img>
            </v-flex>
            <v-flex xs6 v-if="previewMembership.clientCardUrl">
              <b>Bankpas:</b><br>
              <v-img width="250px" :src="previewMembership.clientCardUrl"></v-img>
            </v-flex>
            <v-flex xs12>
              <b>Handtekening:</b><br>
              <img width="250px" crossorigin="anonymous"  id="signature" :src="previewMembership.clientSignature"/>
            </v-flex>
          </v-layout>
        </v-container>


      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-container grid-list-md fluid class="ma-0 pa-0">
          <v-layout row wrap class="ma-0 pa-0">
            <v-flex xs12 md6 class="text-left" v-if="$vuetify.breakpoint.name != 'sm' && $vuetify.breakpoint.name != 'xs'">
              <v-btn
                outlined
                depressed
                color="#8B93A6"
                @click="previewMembershipDialog = false"
                >
                Annuleren
              </v-btn>
            </v-flex>
            <v-flex xs12 md6 class="text-right">
              <v-btn
                dark
                rounded
                :block="$vuetify.breakpoint.name == 'sm' || $vuetify.breakpoint.name == 'xs'"
                :color="companySecondaryColor"
                @click="downloadPDF(previewMembership.type)"
                >
                Downloaden als PDF
                <v-icon right dark>chevron_right</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-actions>

    </v-card>
  </v-dialog>

  <!-- / Delete Dialog \-->
  <v-dialog v-model="removeMembershipData.dialog" max-width="450">
      <v-card>
        <v-card-title class="pr-2" :style=" { backgroundColor: companyPrimaryColor }">
          <h2 class="white--text">Abonnement verwijderen</h2>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeRemoveMembership()">
            <v-icon dark color="white">close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <div class="pt-4 text-center">Abonnement definitief verwijderen? Dit kan niet meer hersteld worden.</div>
        </v-card-text>
        
        <v-divider></v-divider>

        <v-card-actions>
          <v-container grid-list-md fluid class="ma-0 pa-0">
            <v-layout row wrap class="ma-0 pa-0">
              <v-flex xs12 md6 class="text-left" v-if="$vuetify.breakpoint.name != 'sm' && $vuetify.breakpoint.name != 'xs'">
                <v-btn
                  outlined
                  depressed
                  color="#8B93A6"
                  @click="closeRemoveMembership()"
                  >
                  Annuleren
                </v-btn>
              </v-flex>
              <v-flex xs12 md6 class="text-right">
                <v-btn
                  dark
                  rounded
                  :block="$vuetify.breakpoint.name == 'sm' || $vuetify.breakpoint.name == 'xs'"
                  :color="companySecondaryColor"
                  @click="deleteMembership()"
                  >
                  Verwijderen
                  <v-icon right dark>chevron_right</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-actions>

      </v-card>
    </v-dialog>
    <!-- \ Delete Dialog / -->


  </div>
</template>


<script>
import { bus } from "../main";
import db from "../firebase/init";
import _lodash from "lodash";
import AddMembershipForm from "../components/modals/AddMembership.vue";
import platform from 'platform'; 
import moment from 'moment';
import html2canvas from 'html2canvas'
import { jsPDF } from 'jspdf'
// import pdfMake from 'pdfmake'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;


export default {
  components: {
    "add-membership-form": AddMembershipForm,
  },
  name: "Memberships",
  data: () => ({
    activeComp: null,
    activeCompData: null,
    userDataLoaded: false,
    selectedBranchesOriginal: [],
    selectedBranches: [],
    selectedBranchesData: [],
    search: "",
    searchCompanies: "",
    selected: [],
    deleting: false,
    deleteCounter: 0,
    dataloaded: false,
    newQueueDialog: false,
    editQueueDialog: false,
    membershipSelectedPage: 1,
    selectedClientQueueItem: {
      name: "",
      phone: "",
      treatment: "",
      branch: "",
      employee: "",
      salonhubId: "",
      queueEndDate: "",
      queueEndDateMoment: "",
      treatmenTime: "",
    },
    pagination: {
      rowsPerPage: "200",
      sortBy: "dateAdded.seconds",
      descending: false
    },
    memberships: [],
    membershipsScheduled: [],
    selectedClientQueueItemOriginal: {},
    removeBookings: "",
    selected: [],
    branches: [],
    companies: [],
    queuePages: 20,
    headers: [
      {
        text: "Datum",
        align: "left",
        value: "dateAdded",
        width: "200px"
      },
      {
        text: "Type",
        align: "left",
        value: "type",
        width: "200px"
      },
      {
        text: "Naam",
        align: "left",
        value: "lastName"
      },
      {
        text: "Vestiging",
        align: "left",
        value: "branch"
      },
      {
        text: "Bedrag",
        align: "left",
        value: "firstName"
      },
      {
        text: "Download",
        align: "left",
        value: "iban"
      },
      {
        text: "",
        value: "data-table-expand",
        align: "right",
        width: "150px",
        sortable: false
      },
    ],
    yearsToSelect: [],
    previewMembershipDialog: false,
    previewMembership: new Object(),
    membershipTypes: [
      {
        id: "new",
        name: 'Nieuw (3 maanden)'
      },
      {
        id: "extension",
        name: 'Verlenging (3 maanden)'
      },
      {
        id: "newFour",
        name: 'Nieuw (4 maanden)'
      },
      {
        id: "extensionFour",
        name: 'Verlenging (4 maanden)'
      }
    ],
    removeMembershipData: {
      id: null,
      dialog: false,
    }
  }),

  created() {
    this.loadUserComp();
    const currentYear = new Date().getFullYear();
    for (let year = 2022; year <= currentYear; year++) {
      this.yearsToSelect.push(year);
    }
    this.yearsToSelect.reverse();
    this.selectedYear = this.yearsToSelect[0];
  },

  methods: {
    loadUserComp() {
      this.dataloaded = false;
      this.userDataLoaded = false;
      let userCompanies = this.userCompanies;
      this.companies = [];
      let counter = 0

      new Promise((resolve, reject)=>{
        this.userCompanies.forEach(company=>{
          db.collection("companies").doc(company).get()
            .then(doc => {
              let dossierPackage = _.indexOf(doc.data().packages, 'dossier')
              if (dossierPackage >= 0) {
                let company = doc.data();
                company.id = doc.id;
                this.companies.push(company);
              }
              counter++
              if(counter == this.userCompanies.length){
                resolve()
              }
            })
        })
      })
      .then(()=>{
        // REMEMBER SELECTED COMPANY FROM LOCAL STORAGE
        if(this.userRole == 'superadmin'){
          // Super Admins have access to multiple companies 
          let selectedCompany = window.localStorage.getItem('selectedCompany')

          // Check if a selected company is set in the Local Storage
          if(selectedCompany){
            
            // Check if the selected company is an option
            let selectedCompanyIndex = _.findIndex(this.companies, { 'id': selectedCompany })

            // Selected company is an option, set activeComp
            if(selectedCompanyIndex >= 0){
              this.activeCompData = this.companies[selectedCompanyIndex];
              this.activeComp = this.companies[selectedCompanyIndex].id;
              console.log("selectedCompanyIndex: ", selectedCompanyIndex)
              this.loadMembershipData();
              this.userDataLoaded = true;
            } 
            // Selected company is no option, set first company as activeComp 
            else{
              this.activeCompData = this.companies[0];
              this.activeComp = this.companies[selectedCompanyIndex].id;
              window.localStorage.setItem('selectedCompany', this.companies[0].id)
              this.loadMembershipData();
              this.userDataLoaded = true;
            }
          }
          // No selected company is set 
          else {
            this.activeCompData = this.companies[0];
            this.activeComp = this.companies[selectedCompanyIndex].id;
            window.localStorage.setItem('selectedCompany', this.companies[0].id)
            this.loadMembershipData();
            this.userDataLoaded = true;
          }
        }

        // Regular users have 1 company, just get the first
        else {
          this.activeCompData = this.companies[0];
          this.activeComp = this.companies[0].id;
          this.loadMembershipData();
          this.userDataLoaded = true;
        }
      })
    },

    deleteMembershipDialog(item){
      this.removeMembershipData.id = item.id;
      this.removeMembershipData.dialog = true;
    },

    closeRemoveMembership(){
      this.removeMembershipData.dialog = false;
      this.removeMembershipData.id = null;
    },

    async deleteMembership(){
     await db.collection("memberships").doc(this.removeMembershipData.id ).delete()
      .then(()=>{
        this.memberships = this.memberships.filter(item => {return item.id != this.removeMembershipData.id})
      })
      this.closeRemoveMembership()
    },

    downloadPDF(type){
      if(type == 'extension' || type == 'extensionFour' || type == 'extensionSeiseta' || type == 'extensionFourSeiseta' ){
        this.createMembershipExtentionPDF()
      }
      else{
        this.createMembershipPDF()
      }
    },

    createMembershipPDF(){

      var docDefinition = { 
        info: {
          title: 'Beauty by Roos Abonnement van ' +  this.previewMembership.firstName + " " + this.previewMembership.lastName,
          author: 'Beauty by Roos',
          subject: 'Beauty by Roos Abonnement van ' +  this.previewMembership.firstName + " " + this.previewMembership.lastName,
          keywords: 'keywords for document',
        },
        // content: '<h1>This is an sample PDF printed with pdfMake</h1><p>Sven is koning</p>',
        content: [
          
          {
            image: 'logo',
            width: 80,
            alignment: "center",
          },
          { 
            text: "Beauty by Roos Abonnement",
            style: "header",
            alignment: "center",
            fontSize: 20,
            bold: true,
            margin: [0, 30, 0, 30]
          },
          {
            columns: [
              {
                // auto-sized columns have their widths based on their content
                width: '50%',
                text: 'Naam:',
                bold: true,
                margin: [0, 10, 0, 0]
              },
              {
                // star-sized columns fill the remaining space
                // if there's more than one star-column, available width is divided equally
                width: '50%',
                text: this.previewMembership.firstName + " " + this.previewMembership.lastName,
                margin: [0, 10, 0, 0]
              }
            ]
          },
          {
            columns: [
              {
                // auto-sized columns have their widths based on their content
                width: '50%',
                text: 'Adres:',
                bold: true,
                margin: [0, 10, 0, 0]
              },
              {
                // star-sized columns fill the remaining space
                // if there's more than one star-column, available width is divided equally
                width: '50%',
                stack: [this.previewMembership.street, this.previewMembership.zipcode + " " + this.previewMembership.city],
                margin: [0, 10, 0, 0]
              }
            ]
          },
          {
            columns: [
              {
                // auto-sized columns have their widths based on their content
                width: '50%',
                text: 'Type:',
                bold: true,
                margin: [0, 30, 0, 0]
              },
              {
                // star-sized columns fill the remaining space
                // if there's more than one star-column, available width is divided equally
                width: '50%',
                text: this.getMembershipType(this.previewMembership.type),
                margin: [0, 10, 0, 0]
              }
            ]
          },
          {
            columns: [
              {
                // auto-sized columns have their widths based on their content
                width: '50%',
                text: 'Bedrag:',
                bold: true,
                margin: [0, 10, 0, 0]
              },
              {
                // star-sized columns fill the remaining space
                // if there's more than one star-column, available width is divided equally
                width: '50%',
                text: "€ " + this.previewMembership.amount,
                margin: [0, 10, 0, 0]
              }
            ]
          },
          {
            columns: [
              {
                // auto-sized columns have their widths based on their content
                width: '50%',
                text: 'Vestiging:',
                bold: true,
                margin: [0, 30, 0, 0]
              },
              {
                // star-sized columns fill the remaining space
                // if there's more than one star-column, available width is divided equally
                width: '50%',
                text: this.getBranchName(this.previewMembership.branch),
                margin: [0, 30, 0, 0]
              }
            ]
          },
          {
            columns: [
              {
                // auto-sized columns have their widths based on their content
                width: '50%',
                text: 'Datum en tijd:',
                bold: true,
                margin: [0, 10, 0, 0]
              },
              {
                // star-sized columns fill the remaining space
                // if there's more than one star-column, available width is divided equally
                width: '50%',
                text: this.previewMembership.dateAddedFormatted,
                margin: [0, 10, 0, 0]
              }
            ]
          },
          {
            columns: [
              {
                // auto-sized columns have their widths based on their content
                width: '50%',
                text: 'Akkoord met Algemene Voorwaarden:',
                bold: true,
                margin: [0, 10, 0, 0]
              },
              {
                // auto-sized columns have their widths based on their content
                width: '50%',
                text: "https://beautybyroos.nl/algemene-voorwaarden/",
                bold: false,
                margin: [0, 10, 0, 0]
              },
            ]
          },

          
          {
            columns: [
              {
                // auto-sized columns have their widths based on their content
                width: '50%',
                text: 'Paspoort/ID:',
                bold: true,
                margin: [0, 30, 0, 0],
              },
              {
                // star-sized columns fill the remaining space
                // if there's more than one star-column, available width is divided equally
                width: '50%',
                text: 'Bankpas:',
                bold: true,
                margin: [0, 30, 0, 0],
              }
            ]
          },
          {
            columns: [
              {
                // auto-sized columns have their widths based on their content
                width: '50%',
                image: 'clientId',
                width: 200,
              },
              {
                // star-sized columns fill the remaining space
                // if there's more than one star-column, available width is divided equally
                width: '50%',
                image: 'clientCard',
                width: 200,
              }
            ]
          },
          { 
            text: "Handtekening",
            bold: true,
            margin: [0, 20, 0, 0]
          },
          {
            image: 'signature',
            width: 200,
          }
        ],
        images:{
          logo: this.activeCompData.logoUrl,
          signature: this.previewMembership.clientSignature,
          clientId: this.previewMembership.clientIdUrl ? this.previewMembership.clientIdUrl : "",
          clientCard: this.previewMembership.clientCardUrl ? this.previewMembership.clientCardUrl : "",
        },
        defaultStyle: {
          font: 'Roboto'
        } 
      };
      pdfMake.createPdf(docDefinition).download('Beauty by Roos Abonnement van ' +  this.previewMembership.firstName + " " + this.previewMembership.lastName);
      this.previewMembershipDialog = false;
      
    },

    createMembershipExtentionPDF(){

      var docDefinition = { 
        info: {
          title: 'Beauty by Roos Abonnement van ' +  this.previewMembership.firstName + " " + this.previewMembership.lastName,
          author: 'Beauty by Roos',
          subject: 'Beauty by Roos Abonnement van ' +  this.previewMembership.firstName + " " + this.previewMembership.lastName,
          keywords: 'keywords for document',
        },
        // content: '<h1>This is an sample PDF printed with pdfMake</h1><p>Sven is koning</p>',
        content: [
          
          {
            image: 'logo',
            width: 80,
            alignment: "center",
          },
          { 
            text: "Beauty by Roos Abonnement",
            style: "header",
            alignment: "center",
            fontSize: 20,
            bold: true,
            margin: [0, 30, 0, 30]
          },
          {
            columns: [
              {
                // auto-sized columns have their widths based on their content
                width: '50%',
                text: 'Naam:',
                bold: true,
                margin: [0, 10, 0, 0]
              },
              {
                // star-sized columns fill the remaining space
                // if there's more than one star-column, available width is divided equally
                width: '50%',
                text: this.previewMembership.firstName + " " + this.previewMembership.lastName,
                margin: [0, 10, 0, 0]
              }
            ]
          },
          {
            columns: [
              {
                // auto-sized columns have their widths based on their content
                width: '50%',
                text: 'Adres:',
                bold: true,
                margin: [0, 10, 0, 0]
              },
              {
                // star-sized columns fill the remaining space
                // if there's more than one star-column, available width is divided equally
                width: '50%',
                stack: [this.previewMembership.street, this.previewMembership.zipcode + " " + this.previewMembership.city],
                margin: [0, 10, 0, 0]
              }
            ]
          },
          {
            columns: [
              {
                // auto-sized columns have their widths based on their content
                width: '50%',
                text: 'Type:',
                bold: true,
                margin: [0, 30, 0, 0]
              },
              {
                // star-sized columns fill the remaining space
                // if there's more than one star-column, available width is divided equally
                width: '50%',
                text: this.getMembershipType(this.previewMembership.type),
                margin: [0, 10, 0, 0]
              }
            ]
          },
          {
            columns: [
              {
                // auto-sized columns have their widths based on their content
                width: '50%',
                text: 'Bedrag:',
                bold: true,
                margin: [0, 10, 0, 0]
              },
              {
                // star-sized columns fill the remaining space
                // if there's more than one star-column, available width is divided equally
                width: '50%',
                text: "€ " + this.previewMembership.amount,
                margin: [0, 10, 0, 0]
              }
            ]
          },
          {
            columns: [
              {
                // auto-sized columns have their widths based on their content
                width: '50%',
                text: 'Vestiging:',
                bold: true,
                margin: [0, 30, 0, 0]
              },
              {
                // star-sized columns fill the remaining space
                // if there's more than one star-column, available width is divided equally
                width: '50%',
                text: this.getBranchName(this.previewMembership.branch),
                margin: [0, 30, 0, 0]
              }
            ]
          },
          {
            columns: [
              {
                // auto-sized columns have their widths based on their content
                width: '50%',
                text: 'Datum en tijd:',
                bold: true,
                margin: [0, 10, 0, 0]
              },
              {
                // star-sized columns fill the remaining space
                // if there's more than one star-column, available width is divided equally
                width: '50%',
                text: this.previewMembership.dateAddedFormatted,
                margin: [0, 10, 0, 0]
              }
            ]
          },
          {
            columns: [
              {
                // auto-sized columns have their widths based on their content
                width: '50%',
                text: 'Akkoord met Algemene Voorwaarden:',
                bold: true,
                margin: [0, 10, 0, 0]
              },
              {
                // auto-sized columns have their widths based on their content
                width: '50%',
                text: 'https://beautybyroos.nl/algemene-voorwaarden/',
                bold: false,
                margin: [0, 10, 0, 0]
              },
            ]
          },
          { 
            text: "Handtekening",
            bold: true,
            margin: [0, 20, 0, 0]
          },
          {
            image: 'signature',
            width: 200,
          }
        ],
        images:{
          logo: this.activeCompData.logoUrl,
          signature: this.previewMembership.clientSignature,
        },
        defaultStyle: {
          font: 'Roboto'
        } 
      };
      pdfMake.createPdf(docDefinition).download('Beauty by Roos Abonnement van ' +  this.previewMembership.firstName + " " + this.previewMembership.lastName);
      this.previewMembershipDialog = false;
      
    },

    loadBranches() {
      if(this.companies.length > 1){
        this.companies.forEach(company => {
          if(company.id == this.activeComp){
            this.activeCompData = company;
          }
        });
      }
      
      db.collection("branches")
      .where("compId", "==", this.activeComp)
      .get()
      .then(snap => {
        snap.forEach(doc => {
          let branchCollection = doc.data();
          branchCollection.id = doc.id;
          this.branches.push(branchCollection);
        });
      })
    },

    showPreviewMembership(membership){
      this.previewMembership = membership;
      this.previewMembershipDialog = true
    },

    getMembershipType(type){
      let typeName = '';
      this.membershipTypes.forEach(element => {
        if(element.id == type){
          typeName = element.name
        }
      });
      return typeName;
    },   

    getBranchName(branche){
      let name = '';
      this.branches.forEach(element => {
        if(element.id == branche){
          name = element.branchName
        }
      });
      return name;
    },   


    updateData(){
      this.dataloaded = false;
      this.loadMembershipData();
    },

    async loadMembershipData(year){
      this.dataloaded = false;
      let useYear = year ? year : moment().format("YYYY");
      this.selectedYear = useYear;
      this.memberships = new Array();
      let start = moment(useYear,"YYYY").startOf('year').format("YYYY-MM-DD");
      let end = moment(useYear,"YYYY").endOf('year').format("YYYY-MM-DD");


      this.loadBranches();
      await db.collection("memberships")
      .where("companyId", "==", this.activeComp)
      .where("signDate", "<=", end)
      .where("signDate", ">=", start)
      .orderBy("signDate", "desc")
      .get()
      .then(snap => {
        snap.forEach(doc => {
          let membership = doc.data();
          membership.dateAddedFormatted = moment(doc.data().dateAdded.seconds, "X").format("D MMM YYYY H:mm")
          membership.id = doc.id;
          this.memberships.push(membership);
        });
      })
      this.membershipSelectedPage = 1
      this.dataloaded = true;
    },

    updateData() {
      this.loadSelectedBranchesData();
    },

    addNewMembership(){
      bus.$emit("openMembershipDialog");
    },

    editClientQueueItem(item) {
      this.selectedClientQueueItem = Object.assign({}, item);
      this.selectedClientQueueItem.queueEndDatePicker  = moment.unix(item.queueEndDate.seconds).format("YYYY-MM-DD");
      this.selectedClientQueueItemOriginal = _.cloneDeep(this.selectedClientQueueItem);
      this.editQueueDialog = true;
    },

    goToDossier(salonhubId){
      this.$router.push('/dossier?id='+ salonhubId)
    },
  },

  computed: {
    membershipSelectorPages(){
      return Math.ceil(this.memberships.length / this.queuePages)
    },
    demoMode(){
      return this.$store.state.demoMode;
    },
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userBranches() {
      return this.$store.state.userBranches;
    }, 
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    filteredCompanies(){
      return this.companies.filter(company => {
        return company.name.toLowerCase().includes(this.searchCompanies.toLowerCase());
      });
    },
    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    },
    branchesChanged() {
      if (
        _.isEqual(this.selectedBranches, this.selectedBranchesOriginal) == false
      ) {
        return false;
      } else {
        return true;
      }
    },
    branchesWidth(){
      if(this.companies.length > 1 && !this.demoMode){
        return "md6"
      }
      else{
        return "md9"
      }
    }
  }
};
</script>
<style>
.company-package{
  display: list-item;
  margin: 0;
}

.company-package-list{
  padding: 5px 0;
}
</style>
